import { render } from "./SmallFooter.vue?vue&type=template&id=4fd6c28b&ts=true"
import script from "./SmallFooter.vue?vue&type=script&lang=ts"
export * from "./SmallFooter.vue?vue&type=script&lang=ts"

import "./SmallFooter.vue?vue&type=style&index=0&id=4fd6c28b&lang=scss"

import exportComponent from "/Users/alex/lab_dev_test/info-global/info_front_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__